export enum ICON_SOURCE {
  ICONS = 'icons',
  GENERATERSOURCE = 'generatorSource',
}
